import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

// Components
import BodyWrap from "../../utils/BodyWrap";
import ContentDiv from "../../utils/ContentDiv";
import Loader from "../../utils/Loader";
import ErrorText from "../../utils/error-success/ErrorText";
import SectionFooter from "../../utils/SectionFooter";
import VideoPlayer from "./VideoPlayer";

// State
import { getTranslations } from "../../../store/actions/translations";
import { setVideoWatched } from "../../../store/actions/trainingVideos";

// Utils
import { showWatchedBar } from "../../../utils/training/videos";
import { fancyTimeFormat } from "../../../utils/timeHelpers";

const translationSections = ["training_video_page", "training_video_preview_item"];

class VideoPage extends Component {
	constructor(props) {
		super(props);

		this.state = {
			videoId: props.match.params.id,
			vimeoLoaded: false,
			volume: 0,
			loop: false,
			paused: false,
			buffered: 0,
			playedPercentage: 0,
			statusText: ""
		};

		document.addEventListener("visibilitychange", this.handleVisibilityChange, false);
		window.addEventListener("unhandledrejection", this.handleVideoRenderError);
	}

	static initialAction(store, props, translationKey = null) {
		const promises = [];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		let resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		return promises;
	}

	handleVideoRenderError = err => {
		this.setState({ renderError: err });
	};

	// ===================================================================================
	//  LIFE CYCLE
	// ===================================================================================
	componentWillMount() {
		// Grab translations if not already in store
		if (!this.props.translations.pages[this.props.translationKey]) {
			VideoPage.initialAction(null, this.props);
		}
	}

	// ===================================================================================
	//  PLAYER
	// ===================================================================================
	scriptsLoaded = () => {
		this.setState({
			vimeoLoaded: true
		});
	};

	videoError = err => {
		this.setState({
			videoError: err
		});
	};

	handleVolume = event => {
		this.setState({ volume: parseFloat(event.target.value) });
	};

	/*
	 * Runs when the tab is changed and the player is hidden. This will automatically hide the player.
	 */
	handleVisibilityChange = () => {
		if (document.visibilityState === "hidden") {
			this.setState({ paused: true });
		}
	};

	playedTimeUpdate = time => {
		const formattedCurrent = fancyTimeFormat(time.seconds);
		const formattedDuration = fancyTimeFormat(time.duration);

		this.setState({
			statusText: `${formattedCurrent} of ${formattedDuration}`,
			playedPercentage: time.percent * 100
		});
	};

	bufferedProgress = data => {
		// console.log("bufferedProgress:", data.percent, data.percent * 100);
		this.setState({ buffered: data.percent * 100 });
	};

	// ===================================================================================
	//  RENDER
	// ===================================================================================
	render() {
		const { translationsLoading, translations, setWatchedError } = this.props;

		// ===================================
		//	HELMET STUFF
		// ===================================
		let helmet = null;

		let title = "";
		if (this.props.siteInfo.site) {
			title += this.props.siteInfo.site.title;
		}
		if (!!translations.pages[this.props.translationKey]) {
			if (title !== "") title += " | ";
			title += translations.pages[this.props.translationKey].title;
		}

		// helmet = (
		// 	<Helmet>
		// 		<title>{title}</title>
		// 		<meta property="og:title" content={title} />
		// 		<meta property="og:description" content={title} />
		// 		<meta property="twitter:title" content={title} />
		// 	</Helmet>
		// );

		return (
			<BodyWrap>
				{/* {helmet} */}
				<main>
					<div className="page-content">
						<div className="section-row">
							<div className="section section-2--main">
								{translationsLoading ? (
									<Loader />
								) : !!translations.pages[this.props.translationKey] ? (
									<ContentDiv>
										{translations.pages[this.props.translationKey].content}
									</ContentDiv>
								) : null}
							</div>
							{!translationsLoading && (
								<div className="section section-2--side">
									<SectionFooter href={`/training/videos`}>
										{translations.sections.training_video_page.back_link}
									</SectionFooter>
									{showWatchedBar(
										this.state.videoId,
										this.props.user,
										[],
										translations
									)}
								</div>
							)}
						</div>
						<div className="section-row section-row--block video-wrapper">
							{this.state.renderError ? (
								<ErrorText classes={`pt1`} errors={"Unable to load video"} />
							) : (
									<VideoPlayer
										videoId={this.state.videoId}
										volume={this.state.volume}
										paused={this.state.paused}
										buffered={this.state.buffered}
										playedPercentage={this.state.playedPercentage}
										statusText={this.state.statusText}
										handleVideoError={this.videoError}
										setPlayHandler={paused => this.setState({ paused })}
										handleBufferedProgress={this.bufferedProgress}
										handlePlayedTimeUpdate={this.playedTimeUpdate}
										setVideoWatched={() =>
											this.props.setVideoWatched(this.state.videoId)
										}
										handleVolume={this.handleVolume}
									/>
								)}
							{this.state.videoError && (
								<ErrorText classes={`pt1`} errors={this.state.videoError} />
							)}
							{!!setWatchedError && (
								<ErrorText classes={`pt1`} errors={setWatchedError} />
							)}
						</div>
					</div>
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		user: state.user.reviewer.user,
		siteInfo: state.siteInfo,
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations,
		content: state.content,
		setWatchedLoading: !!state.trainingVideos.setWatchedLoading
			? state.trainingVideos.setWatchedLoading
			: 0,
		setWatchedError: !!state.trainingVideos.setWatchedError
			? state.trainingVideos.setWatchedError
			: 0
	};
};

export default connect(
	mapStateToProps,
	{ getTranslations, setVideoWatched }
)(VideoPage);



// WEBPACK FOOTER //
// ./src/components/training/videos/VideoPage.js